import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getUserMemberships } from '../../../api/memberships';
import { UseUserMembership } from '../../../ts/interface/membership.interface';

const useUserMembership = (
  body?: UseUserMembership,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['userMembership', body],
    queryFn: () => getUserMemberships(body),
    ...options,
  });
};

export default useUserMembership;
